export enum FeeFormula {
    'OFFICE' = 'FEE_FORMULA-OFFICE',
    'DEPARTMENT' = 'FEE_FORMULA-DEPARTMENT',
    'EFFECTIVE_DATE' = 'EFFECTIVE_DATE',
    'REC_STATUS' = 'FEE_FORMULA-REC_STATUS',
    'PROFILE_CHANGE_STATUS' = 'FEE_FORMULA-PROFILE_CHANGE_STATUS',
    'FEE_FORMULA_NAME' = 'FEE_FORMULA-FEE_FORMULA_NAME',
    'FEE_TYPE_NAME' = 'FEE_FORMULA-FEE_TYPE_NAME',
    'V_FEE_PARTYTYPE' = 'FEE_FORMULA-V_FEE_PARTYTYPE',
    'FEE_CURRENCY' = 'FEE_FORMULA-FEE_CURRENCY',
    'USE_FEE_EXTR_SYSTEM' = 'FEE_FORMULA-USE_FEE_EXTR_SYSTEM',
    'FEE_FORMULA_DESCRIPTION' = 'FEE_FORMULA-FEE_FORMULA_DESCRIPTION',
    'DEDUCT_FROM' = 'FEE_FORMULA-DEDUCT_FROM',
    'APPLY_FEE' = 'FEE_FORMULA-APPLY_FEE',
    'FIXED_FEE_METHOD' = 'FEE_FORMULA-FIXED_FEE_METHOD',
    'FEE_TX_CD' = 'FEE_FORMULA-FEE_TX_CD',
    'FEES_SUSP_ACC_NO' = 'FEE_FORMULA-FEES_SUSP_ACC_NO',
    'FEES_SUSP_ACC_CCY' = 'FEE_FORMULA-FEES_SUSP_ACC_CCY',
    'FEES_SUSP_ACC_OFFICE' = 'FEE_FORMULA-FEES_SUSP_ACC_OFFICE',
    'METHOD' = 'FEE_FORMULA-METHOD',
    'TIER_TYPE' = 'FEE_FORMULA-TIER_TYPE',
    'FIXED_FEE' = 'FEE_FORMULA-FIXED_FEE',
    'PERCENTAGE_FEE' = 'FEE_FORMULA-PERCENTAGE_FEE',
    'MIN_FEE' = 'FEE_FORMULA-MIN_FEE',
    'MAX_FEE' = 'FEE_FORMULA-MAX_FEE',
    'DETAILS' = 'DETAILS',
    'TIME_STAMP' = 'TIME_STAMP',
    'UID' = 'VIRTUAL-UID',
    'PROFILE_UPDATE_PK' = 'PROFILE_UPDATE_PK',
    'PU_TIME_STAMP' = 'PU_TIME_STAMP',
    'NOTE' = 'NOTE'
};
